"use strict";

import Vue from 'vue';
import _axios from "@/api";
import router from "../routes";
import UserInfoTool from './user-info-tool';
import {
    message as Message
} from 'ant-design-vue';

_axios.interceptors.request.use(
    function (config) {
        let _token = UserInfoTool.getToken();
        if (_token) {
            config.headers.authorization = _token;
        } else {
            router.push({
                path: '/login'
            });
        }
        // if aliyun oss request
        // send directly
        if (config.url.match(/apailang.oss-cn-hangzhou.aliyuncs.com/)) {
            config.baseURL = '';
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // if aliyun oss request
        // would not fail
        if (response.request.responseURL.match(/apailang.oss-cn-hangzhou.aliyuncs.com/)) {
            return response;
        }
        if (/blob/i.test(response.config.responseType)) {
            return response;
        }
        
        if (response.data.code === 200) {
            if (response.headers.authorization) {
                UserInfoTool.setToken(response.headers.authorization);
            }
            return response.data.data;
            
        } else if (response.data.code === 202) {
            router.push({
                path: '/login'
            });
            Message.error(response.data.msg)
            return Promise.reject(new Error('登录失效，请重新登录'));

        } else if (response.data.code === 212) {
            router.push({
                path: '/login'
            });
            Message.error(response.data.msg)
            return Promise.reject(new Error('您的账号在其他地方登录,您已被强制下线!如非本人操作,请及时修改密码!'));

        } else if (response.data.code === 204) {
            try {
                sessionStorage.removeItem('_token');
            } catch (error) {
                console.error(error)
            }
            Message.error(response.data.msg)
            return Promise.reject(new Error('登录失效，用户不存在'));
        }else if (response.data.code === 5006) {
            Message.error('用户名或账号重复，请重新输入')
            return Promise.reject(new Error(response.data.msg));
            
        } else if (response.data.code === 200001) {
            //票券操作账户储值或者余额不够
            return Promise.reject(response.data);
        } else {
            Message.error(response.data.msg)
            return Promise.reject(new Error(response.data.msg));
        }
        
    },
    function (error) {
        // Do something with response error
        if(Boolean(error.response.data) && error.response.data.msg) {
            Message.error(error.response.data.msg);
        }
        return Promise.reject(error);
    }
);

Vue.prototype.$axios = _axios;
